"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressSchema = void 0;
exports.addressSchema = {
    type: ['object', 'null'],
    required: [
        'municipalityName',
        'postalCode',
        'provinceID',
        'streetDirectionID',
        'streetName',
        'streetNumber',
        'streetTypeID',
        'unitNumber',
    ],
    properties: {
        municipalityName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
            default: '',
        },
        postalCode: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        provinceID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        streetDirectionID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
            default: '',
        },
        streetName: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
            default: '',
        },
        streetNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
            default: '',
        },
        streetTypeID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
        unitNumber: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
            default: '',
        },
    },
};
exports.default = exports.addressSchema;
